(() => {
  const page = document.querySelector('[data-fv-page]');
  if (!page || page.dataset.initialized) return;
  page.dataset.initialized = 'true';
  const forms = [...page.querySelectorAll('.fv-form')];
  const choices = [...page.querySelectorAll('.fv-plan input')];
  const root = window.Shopify?.routes?.root || '/';
  const eventLibrary = import('@shopify/events').catch(() => null);
  import('@theme/view-event-elements').catch(() => {});
  const storageKey = `feluvira-choice:${page.dataset.product}`;
  let current;
  const safely = (fn) => { try { return fn(); } catch { return null; } };
  function select(value, persist = true) {
    current = choices.find(input => input.value === value) || choices.find(input => input.checked) || choices[0];
    if (!current) return;
    choices.forEach(input => { input.checked = input.value === current.value; });
    forms.forEach(form => {
      form.querySelector('[data-fv-quantity]').value = current.dataset.quantity;
      const selling = form.querySelector('[data-fv-selling]');
      selling.value = current.dataset.plan;
      selling.disabled = !current.dataset.plan;
      form.querySelector('[data-fv-shipping]').textContent = current.dataset.shipping;
      form.querySelector('[data-fv-included]').textContent = current.dataset.label;
      form.querySelectorAll('.fv-plan').forEach(card => {
        const giftPanel = card.querySelector('[data-fv-gift-panel]');
        if (giftPanel) giftPanel.hidden = !card.querySelector('input').checked;
      });
      form.querySelector('[data-fv-charge]').textContent = `Today: ${current.dataset.formatted} before shipping and tax.${current.dataset.plan ? ` Then ${current.dataset.formatted} ${current.dataset.label.split(' · ')[1]}, plus applicable shipping and tax.` : ''}`;
      form.querySelector('[data-fv-recurring]').hidden = !current.dataset.plan;
    });
    page.querySelectorAll('[data-fv-price]').forEach(el => { el.textContent = current.dataset.formatted; });
    page.querySelector('[data-fv-sticky-label]').textContent = current.dataset.label;
    if (persist) safely(() => sessionStorage.setItem(storageKey, current.value));
  }
  choices.forEach(input => input.addEventListener('change', () => select(input.value)));
  const isReload = performance.getEntriesByType('navigation')[0]?.type === 'reload';
  select(isReload ? safely(() => sessionStorage.getItem(storageKey)) : null);
  forms.forEach(form => form.addEventListener('submit', async event => {
    event.preventDefault();
    if (page.dataset.busy === 'true') return;
    page.dataset.busy = 'true';
    const buttons = [...page.querySelectorAll('.fv-buy, [data-fv-sticky-buy]')].filter(el => el.tagName === 'BUTTON');
    const previouslyDisabled = buttons.map(button => button.disabled);
    buttons.forEach(button => { button.disabled = true; });
    forms.forEach(f => { f.querySelector('[data-fv-error]').textContent = ''; });
    let deferred;
    let events;
    try {
      const body = new FormData(form);
      events = await eventLibrary;
      if (events) {
        deferred = events.CartLinesUpdateEvent.createPromise();
        deferred.promise.catch(() => {});
        form.dispatchEvent(new events.CartLinesUpdateEvent({
          action: 'add', context: 'product',
          lines: [{merchandiseId: body.get('id'), quantity: Number(body.get('quantity'))}],
          promise: deferred.promise,
          detail: {productId: page.dataset.product, sellingPlanId: body.get('selling_plan') || null},
        }));
      }
      const response = await fetch(`${root}cart/add.js`, {method: 'POST', body, headers: {'Accept': 'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'This item could not be added. Please try again.');
      if (deferred) {
        try {
          const cartResponse = await fetch(`${root}cart.js`, {headers: {'Accept': 'application/json'}});
          if (!cartResponse.ok) throw new Error('Cart event state could not be refreshed.');
          const cart = await cartResponse.json();
          deferred.resolve({cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), userErrors: [], warnings: [], detail: {items: cart.items, didError: false, source: 'feluvira-product-redesign', productId: page.dataset.product}});
        } catch (eventError) { deferred.reject(eventError); }
      }
      const drawer = document.getElementById('cart-drawer');
      if (drawer && deferred) {
        try {
          const { sectionRenderer } = await import('@theme/section-renderer');
          await sectionRenderer.renderSection('cart-drawer-section', { cache: false, mode: 'hydration', injectStylesheet: true });
          await customElements.whenDefined('theme-drawer');
          drawer.open();
          buttons.forEach((button, i) => { button.disabled = previouslyDisabled[i]; });
          page.dataset.busy = 'false';
        } catch { window.location.assign(`${root}cart`); }
      } else window.location.assign(`${root}cart`);
    } catch (error) {
      deferred?.reject(error);
      if (events) form.dispatchEvent(new events.CartErrorEvent({error: error.message, code: 'SERVICE_UNAVAILABLE'}));
      form.querySelector('[data-fv-error]').textContent = error.message;
      buttons.forEach((button, i) => { button.disabled = previouslyDisabled[i]; });
      page.dataset.busy = 'false';
    }
  }));
  page.querySelector('[data-fv-sticky-buy]').addEventListener('click', () => {
    const button = forms[0]?.querySelector('button[type="submit"]');
    if (button && !button.disabled) forms[0].requestSubmit(button);
  });
  page.querySelectorAll('[data-fv-copy-code]').forEach(button => button.addEventListener('click', async () => {
    const code = button.dataset.fvCopyCode;
    const status = button.closest('.fv-code-offer').querySelector('[data-fv-copy-status]');
    try {
      await navigator.clipboard.writeText(code);
      status.textContent = `${code}: ${button.dataset.copied}`;
      button.textContent = button.dataset.copied;
      setTimeout(() => { button.textContent = `${code} ⧉`; }, 2500);
    } catch { status.textContent = code; }
  }));
  const image = page.querySelector('#fv-main-image');
  page.querySelectorAll('[data-fv-gallery]').forEach(button => button.addEventListener('click', () => {
    image.src = button.dataset.src;
    image.srcset = button.dataset.srcset;
    image.alt = button.dataset.alt;
    image.dataset.full = button.dataset.full || button.dataset.src;
    page.querySelectorAll('[data-fv-gallery]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
  }));
  const dialog = page.querySelector('[data-fv-media-dialog]');
  const content = dialog.querySelector('[data-fv-media-content]');
  const zoomDetail = dialog.querySelector('[data-fv-zoom-detail]');
  let mediaOpener;
  const resetZoom = () => { content.classList.remove('fv-is-zoomed'); zoomDetail.setAttribute('aria-pressed', 'false'); zoomDetail.textContent = 'Zoom image'; };
  const resetMedia = () => { content.querySelectorAll('video').forEach(video => { video.pause(); video.currentTime = 0; }); content.replaceChildren(); resetZoom(); mediaOpener?.focus(); };
  zoomDetail.addEventListener('click', () => {
    const zoomed = content.classList.toggle('fv-is-zoomed');
    zoomDetail.setAttribute('aria-pressed', String(zoomed));
    zoomDetail.textContent = zoomed ? 'Fit image' : 'Zoom image';
  });
  dialog.addEventListener('close', resetMedia);
  dialog.querySelector('[data-fv-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  page.querySelector('[data-fv-zoom]').addEventListener('click', event => {
    mediaOpener = event.currentTarget;
    zoomDetail.hidden = false;
    const enlarged = new Image(); enlarged.src = image.dataset.full || image.src; enlarged.alt = image.alt; content.replaceChildren(enlarged); dialog.showModal();
  });
  page.querySelectorAll('[data-fv-video]').forEach(button => button.addEventListener('click', () => {
    if (dialog.open) dialog.close();
    mediaOpener = button;
    zoomDetail.hidden = true;
    content.replaceChildren(page.querySelector(`#fv-video-${button.dataset.fvVideo}`).content.cloneNode(true));
    const video = content.querySelector('video');
    const captions = content.querySelector('track');
    if (captions) video.append(captions);
    video.autoplay = false; video.controls = true; video.preload = 'metadata';
    video.addEventListener('ended', () => dialog.close(), {once: true});
    dialog.showModal(); video.play().catch(() => {});
  }));
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('fv-enter'); observer.unobserve(entry.target); } }), {threshold: .2});
    page.querySelectorAll('[data-fv-entrance]').forEach(el => observer.observe(el));
  }
  const popup = page.querySelector('[data-fv-popup]');
  const teaser = page.querySelector('[data-fv-teaser]');
  const frequencyKey = 'feluvira-guide-dismissed';
  let popupOpener;
  function openPopup() { if (dialog.open || popup.open) return; popupOpener = document.activeElement; popup.showModal(); }
  function dismissPopup() { popup.close(); }
  popup.addEventListener('close', () => { safely(() => localStorage.setItem(frequencyKey, String(Date.now()))); teaser.hidden = false; popupOpener?.focus(); });
  popup.querySelector('[data-fv-popup-close]').addEventListener('click', dismissPopup);
  popup.querySelector('[data-fv-popup-guide]').addEventListener('click', dismissPopup);
  teaser.addEventListener('click', openPopup);
  const dismissed = Number(safely(() => localStorage.getItem(frequencyKey))) || 0;
  if (Date.now() - dismissed > Number(page.dataset.popupDays) * 86400000) {
    const showWhenIdle = () => {
      if (document.hidden || dialog.open || document.querySelector('theme-drawer[open]') || page.dataset.busy === 'true') { window.setTimeout(showWhenIdle, 10000); return; }
      openPopup();
    };
    window.setTimeout(showWhenIdle, Number(page.dataset.popupDelay) * 1000);
  } else teaser.hidden = false;
})();

